import { TableHead } from "@mui/material";
import { type ComponentProps, type Ref, forwardRef } from "react";
import { useTableVirtualizedContext } from "./context";

export const VirtuosoTableHead = forwardRef(function VirtuosoTableHead(
  { children, ...props }: ComponentProps<"thead">,
  ref: Ref<HTMLTableSectionElement>
) {
  const { slotProps } = useTableVirtualizedContext();

  return (
    <TableHead {...props} ref={ref} {...slotProps?.tableHead}>
      {children}
    </TableHead>
  );
});
